import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/stats/base/dists/poisson/cdf';
import __var_2__ from '@stdlib/stats/base/dists/poisson/ctor';
import __var_3__ from '@stdlib/stats/base/dists/poisson/kurtosis';
import __var_4__ from '@stdlib/stats/base/dists/poisson/logpmf';
import __var_5__ from '@stdlib/stats/base/dists/poisson/mean';
import __var_6__ from '@stdlib/stats/base/dists/poisson/median';
import __var_7__ from '@stdlib/stats/base/dists/poisson/mgf';
import __var_8__ from '@stdlib/stats/base/dists/poisson/mode';
import __var_9__ from '@stdlib/stats/base/dists/poisson/pmf';
import __var_10__ from '@stdlib/stats/base/dists/poisson/quantile';
import __var_11__ from '@stdlib/stats/base/dists/poisson/skewness';
import __var_12__ from '@stdlib/stats/base/dists/poisson/stdev';
import __var_13__ from '@stdlib/stats/base/dists/poisson/variance';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace poisson
*/
var poisson = {};

/**
* @name cdf
* @memberof poisson
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/poisson/cdf}
*/
setReadOnly( poisson, 'cdf', __var_1__);

/**
* @name Poisson
* @memberof poisson
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/poisson/ctor}
*/
setReadOnly( poisson, 'Poisson', __var_2__);

/**
* @name kurtosis
* @memberof poisson
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/poisson/kurtosis}
*/
setReadOnly( poisson, 'kurtosis', __var_3__);

/**
* @name logpmf
* @memberof poisson
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/poisson/logpmf}
*/
setReadOnly( poisson, 'logpmf', __var_4__);

/**
* @name mean
* @memberof poisson
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/poisson/mean}
*/
setReadOnly( poisson, 'mean', __var_5__);

/**
* @name median
* @memberof poisson
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/poisson/median}
*/
setReadOnly( poisson, 'median', __var_6__);

/**
* @name mgf
* @memberof poisson
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/poisson/mgf}
*/
setReadOnly( poisson, 'mgf', __var_7__);

/**
* @name mode
* @memberof poisson
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/poisson/mode}
*/
setReadOnly( poisson, 'mode', __var_8__);

/**
* @name pmf
* @memberof poisson
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/poisson/pmf}
*/
setReadOnly( poisson, 'pmf', __var_9__);

/**
* @name quantile
* @memberof poisson
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/poisson/quantile}
*/
setReadOnly( poisson, 'quantile', __var_10__);

/**
* @name skewness
* @memberof poisson
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/poisson/skewness}
*/
setReadOnly( poisson, 'skewness', __var_11__);

/**
* @name stdev
* @memberof poisson
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/poisson/stdev}
*/
setReadOnly( poisson, 'stdev', __var_12__);

/**
* @name variance
* @memberof poisson
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/poisson/variance}
*/
setReadOnly( poisson, 'variance', __var_13__);


// EXPORTS //
export default poisson;

export { __var_1__ as cdf, __var_2__ as Poisson, __var_3__ as kurtosis, __var_4__ as logpmf, __var_5__ as mean, __var_6__ as median, __var_7__ as mgf, __var_8__ as mode, __var_9__ as pmf, __var_10__ as quantile, __var_11__ as skewness, __var_12__ as stdev, __var_13__ as variance};